import React from "react";
import connectivityihub from "../images/connectivityihub.png";
const LandingPage = () => {
  return (
    <div className="ihub-public-main">
      <h2>Quickly connect Jira across any system!</h2>
      <p>
        Get your integrations up and running in minutes! iHUB is a no-code, easy to use, integrations hub that securely integrates any system.
        Triggers on Jira events or incoming webhooks from other systems.
      </p>
      <img src={connectivityihub} width="60%" height="60%" />
      <br />
      <br />
      <h4>Integrations</h4>
      <ul>
        <li>Configure integration processes.</li>
        <li>Decide their triggers and outcomes.</li>
      </ul>

      <h4>Credentials</h4>
      <ul>
        <li>Securely connect using OAuth2, Basic-Auth, or header tokens.</li>
        <li>Set up reusable authentication details for APIs.</li>
      </ul>

      <h4>Execution Log</h4>
      <ul>
        <li>See the history and details of all integration processes.</li>
      </ul>

      <h4>Notifications</h4>
      <ul>
        <li>Check system alerts, including rate limits and other internal events.</li>
      </ul>
    </div>
  );
};
export default LandingPage;
